// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ZZ4C","left":"styles_left__27She","desktopActions":"styles_desktopActions__1_V_d","title":"styles_title__3HuGx"};